import { createContext, useContext, type ReactNode } from "react";
import { useAssessmentMigration } from "@/hooks/useAssessmentMigration";

interface MigrationContextValue {
  hydrating: boolean;
}

const MigrationContext = createContext<MigrationContextValue>({ hydrating: false });

/**
 * Runs the bidirectional sync between localStorage and the user's
 * assessment_results row, and exposes a `hydrating` flag via context so
 * result pages can show a loader instead of a false "no data" empty state.
 */
const AssessmentMigrationRunner = ({ children }: { children?: ReactNode }) => {
  const { hydrating } = useAssessmentMigration();
  return (
    <MigrationContext.Provider value={{ hydrating }}>
      {children ?? null}
    </MigrationContext.Provider>
  );
};

export const useAssessmentHydrating = () => useContext(MigrationContext).hydrating;

export default AssessmentMigrationRunner;
